import type { Cart, SetShippingMethodsOnCartInput } from '~/modules/GraphQL/types';
import { CustomHeaders, CustomQuery, UseContextReturn } from '~/types/core';

export const setShippingMethodsOnCartCommand = {
  execute: async (
    context: UseContextReturn,
    shippingMethodParams: SetShippingMethodsOnCartInput,
    customQuery: CustomQuery,
    customHeaders: CustomHeaders,
  ): Promise<Cart | null> => {
    const { data, errors } = await context.app.$vsf.$magento.api.setShippingMethodsOnCart(shippingMethodParams, customQuery, customHeaders);

    // TODO: Find out why 'Cart' doesn't match the type of the response data.
    if (errors && errors.length > 0) {
      throw errors[0];
    }
    return (data?.setShippingMethodsOnCart?.cart as unknown as Cart) ?? null;
  },
};
